<template>
  <div class="mx-auto">
    <TitleWrapper
      :filter-option="false"
      title="Feat_List"
      tooltip-title="Feat_List"
      :display-breadcrumb="false"
    />
    <div v-if="isLoading && !featureList.length" class="mt-28"><Loader :content="true" /></div>
    <TableWrapper v-else table-height="h-auto">
      <THead>
        <TRHead>
          <TH v-for="(head, index) in tableHeads" :key="index">{{ head }}</TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(feature, index) in featureList" :key="index">
          <TD>
            <span v-i18n="title">{{ feature.name }}</span>
          </TD>
          <TD>
            <ToggleButton
              v-model="feature.status"
              class="mt-1"
              :is-status-hide="true"
              @change="toggleFeature(feature.name, index)"
            />
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
  </div>
</template>

<script>
import {
  TableWrapper,
  THead,
  TRHead,
  TH,
  TBody,
  TRBody,
  TD,
} from '@src/components/UiElements/TableElements/index.js'
import TitleWrapper from '@components/TitleWrapper.vue'
import ToggleButton from '@src/components/BaseComponent/toggleButton.vue'
import { mapActions, mapState } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import isArray from 'lodash/isArray'
import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants.js'
export default {
  components: {
    TitleWrapper,
    TableWrapper,
    THead,
    TRHead,
    TH,
    TBody,
    TRBody,
    TD,
    ToggleButton,
    Loader,
  },
  data() {
    return {
      MYQAMPUS_FEATURE_NAMES,
      leftBar: 'leftBar',
      featureList: [],
      isLoading: false,
      title: 'title',
    }
  },
  computed: {
    ...mapState('layout', ['currentCampusScope']),

    allFeatureNames() {
      return [
        MYQAMPUS_FEATURE_NAMES.STUDENTS_CAMPUS_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.STUDENTS_SECTION_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.STUDENTS_PERIOD_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.STUDENTS_DAILY_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.STAFF_CAMPUS_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.STAFF_DAILY_ATTENDANCE,
        MYQAMPUS_FEATURE_NAMES.TIME_TABLE_MANAGER,
        MYQAMPUS_FEATURE_NAMES.SYLLABUS_MANAGER,
        MYQAMPUS_FEATURE_NAMES.ASSIGNMENT,
        MYQAMPUS_FEATURE_NAMES.FEE_MANAGER,
        MYQAMPUS_FEATURE_NAMES.PICKUP_MANAGER,
        MYQAMPUS_FEATURE_NAMES.ANNOUNCEMENTS,
        MYQAMPUS_FEATURE_NAMES.SUPPORT_QUERY,
        MYQAMPUS_FEATURE_NAMES.EXAMS_MANAGER,
        MYQAMPUS_FEATURE_NAMES.GRADES_MANAGER,
      ]
    },

    tableHeads() {
      return ['Feature Name', 'Status']
    },
  },

  watch: {
    currentCampusScope() {
      this.initializeFeatureList()
    },
  },

  created() {
    this.initializeFeatureList()
  },

  methods: {
    ...mapActions('layout', ['setDisabledFeatures', 'getDisabledFeatures']),
    toggleFeature(feature, index) {
      let payload = {
        feature_name: feature,
      }
      this.setDisabledFeatures(payload).catch(() => {
        this.featureList[index].status = false
      })
    },
    initializeFeatureList() {
      this.isLoading = true

      this.getDisabledFeatures()
        .then((response) => {
          const fetchedFeatureNames =
            response?.disabled_features?.map((item) => item.feature_name) || []
          this.featureList = this.allFeatureNames.map((name) => {
            return {
              name,
              status: !fetchedFeatureNames.includes(name),
            }
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
